export var TabsNode;
(function (TabsNode) {
    TabsNode["Tab"] = "yfm_tab";
    TabsNode["TabsList"] = "yfm_tabs_list";
    TabsNode["TabPanel"] = "yfm_tab_panel";
    TabsNode["Tabs"] = "yfm_tabs";
})(TabsNode || (TabsNode = {}));
export var TabsAttrs;
(function (TabsAttrs) {
    TabsAttrs["class"] = "class";
    TabsAttrs["dataDiplodocGroup"] = "data-diplodoc-group";
})(TabsAttrs || (TabsAttrs = {}));
export var TabsListAttrs;
(function (TabsListAttrs) {
    TabsListAttrs["class"] = "class";
    TabsListAttrs["role"] = "role";
})(TabsListAttrs || (TabsListAttrs = {}));
export var TabAttrs;
(function (TabAttrs) {
    TabAttrs["id"] = "id";
    TabAttrs["class"] = "class";
    TabAttrs["role"] = "role";
    TabAttrs["ariaControls"] = "aria-controls";
    TabAttrs["ariaSelected"] = "aria-selected";
    TabAttrs["tabindex"] = "tabindex";
    TabAttrs["dataDiplodocKey"] = "data-diplodoc-key";
    TabAttrs["dataDiplodocid"] = "data-diplodoc-id";
    TabAttrs["dataDiplodocIsActive"] = "data-diplodoc-is-active";
})(TabAttrs || (TabAttrs = {}));
export var TabPanelAttrs;
(function (TabPanelAttrs) {
    TabPanelAttrs["id"] = "id";
    TabPanelAttrs["class"] = "class";
    TabPanelAttrs["role"] = "role";
    TabPanelAttrs["dataTitle"] = "data-title";
    TabPanelAttrs["ariaLabelledby"] = "aria-labelledby";
})(TabPanelAttrs || (TabPanelAttrs = {}));
